<template>
    <div>
        <v-btn :block="block" color="#25D366" dark @click="openApp">
            <v-icon small class="mr-2">fab fa-whatsapp</v-icon>
            {{ $t('WhatsApp') }}
        </v-btn>
        <div v-show="false">
            <a :href="webUrl" target="_blank" ref="webUrl">webUrl</a>
            <a :href="appUrl" data-action="share/whatsapp/share" ref="appUrl">appUrl</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WhatsAppShare',
    props: {
        url: {},
        block: Boolean,
    },
    data() {
        return {
            timeoutToken: null,
            resolver: null,
            appUrl: `whatsapp://send?text=${this.url}`,
            webUrl: `https://web.whatsapp.com/send?text=${this.url}`,
        };
    },
    mounted() {
        window.addEventListener('blur', this.handleBlur);
    },
    beforeDestroy() {
        window.removeEventListener('blur', this.handleBlur);
    },
    methods: {
        handleBlur() {
            clearTimeout(this.timeoutToken);
            if (this.resolver) {
                this.resolver(true);
            }
        },
        openApp() {
            new Promise(resolve => {
                this.resolver = resolve;

                const start = Date.now();

                this.timeoutToken = setTimeout(() => {
                    if (Date.now() - start > 1250) {
                        this.resolver(true);
                    } else {
                        this.resolver(false);
                    }
                }, 1000);

                this.$refs.appUrl.click();
            }).then(nativeAppExists => {
                if (!nativeAppExists) {
                    this.$refs.webUrl.click();
                }
                this.resolver = false;
            });
        },
    },
};
</script>
